export default __webpack_public_path__ + "static/media/rubric.6ae348e4.svg";